import { useMainContext } from '../callContext/MainContext';
import {accountPageText as text} from "../database/Text";
import { useNavigate } from 'react-router-dom';
import sad from "../assets/icons/smiley.png"
const Modal = ({showModel,setShowModel,reason,setLoading}) => {
  const navigate=useNavigate();
  const {language}=useMainContext();
  const handleOkButtonClick=()=>
  {
    // setLoading(true);
    navigate("/subs/packs")
    setShowModel(false)
  }
  return (
    <div className={`fixed top-0 bg-black/70 z-[2000] h-screen w-full max-w-[500px] transition-opacity duration-500 ease-out flex justify-center items-center  ${!showModel?"opacity-0 -z-[1000]":" opacity-100"} `}>
    <div className=' yellow-theme-color p-4 w-5/6 rounded-md '>
      <div className='flex flex-col justify-center items-center my-3'>
      <img src={sad}  alt="sad" className='h-20'/>
      <h1 className='text-center w-3/4'>{reason}</h1>
      <button className='p-2 rounded-md bg-white my-3 w-3/4' onClick={ ()=>
        {
          handleOkButtonClick()
        }}>{text?.okBtnText?.[language]}</button>
      {/* <button className='border-2 border-white p-2 rounded-md text-white w-3/4' onClick={handleYesClick}>Yes</button> */}
      </div>
    </div>
   </div>
  )
}

export default Modal